import React from 'react'

interface IProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  icon: string
  size?: number
  arrowColor?: string
  children?: React.ReactNode
}

const IconMenu = ({
  isOpen,
  setIsOpen,
  icon,
  size = 42,
  arrowColor = 'text-blue-500',
  children
}: IProps) => {
  return (
    <button
      onClick={() => setIsOpen(!isOpen)}
      className="group relative flex size-14 items-center justify-center rounded-xl p-2 transition-all duration-300 active:scale-95"
    >
      <div className="relative z-10 flex items-center">
        {children ?? (
          <div className="relative">
            {/* CSS background-image div instead of <img>. Plain <img> migration
                killed Trigger D Phase 1 (style="color:transparent") but Phase 3
                attribute-order drift on `src` still fired. Background-image
                div then drifts on the inline `url(...)` → browser-normalized
                `url("...")` quoting. suppressHydrationWarning (Phase 5) is the
                correct escape hatch for this genuine React-tree style-attribute
                mismatch: React keeps SSR DOM, no fallback, no recoverable error
                → recorder + PostHog both quiet. Computed style is identical
                (same icon renders). Sizing via Tailwind className, not inline
                style. See CLAUDE.md "Trigger D Phase 5". */}
            <div
              role="img"
              aria-label="SpotMe"
              className={`bg-contain bg-center bg-no-repeat transition-transform duration-300 group-hover:scale-105 ${
                size === 36 ? 'size-9' : 'size-[42px]'
              }`}
              style={{ backgroundImage: `url("${icon}")` }}
              suppressHydrationWarning
            />

            {/* Arrow */}
            <div
              className={`absolute transition-all duration-300 ${
                isOpen ? '-top-2 -right-2' : '-top-1 -right-1'
              }`}
            >
              <svg
                className={`size-5 transition-all duration-300 ${arrowColor} ${
                  isOpen ? 'rotate-180' : 'rotate-0'
                }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>
        )}
      </div>

      {/* Ripple effect on click */}
      <div className="absolute inset-0 rounded-xl bg-blue-400 opacity-0 transition-opacity duration-150 active:opacity-30" />
    </button>
  )
}

export default React.memo(IconMenu)
